<template>
    <b-card>
        <div class="row">
            <div class="col-md-12 mb-1">
                <label class="form-label">Sicil Dosyası</label>
                <v-select-list v-on:input="getValues" placeholder="Sicil Dosyası" v-model="document" label="Path" :options="documents"/>
                <b-form-checkbox class="mt-50" v-model="rememberDocument">Sicil Dosyasını Hatırla</b-form-checkbox>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Sicil Dosyası Değer Türü</label>
                <v-select-list placeholder="Sicil Dosyası Değer Türü" v-model="type" label="Name" :options="types"/>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Değer İsmi</label>
                <input class="form-control" v-model="registryDocumentValue.Name" placeholder="Değer İsmi" />
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Değer Kodu</label>
                <input class="form-control" type="number" v-model="registryDocumentValue.Code" placeholder="Değer Kodu" />
            </div>
            <div class="col-12 mb-1" v-if="registryDocumentValue.Id">
                <div class="alert alert-dark mb-0">
                    <div class="alert-body">{{registryDocumentValue.Id}}</div>
                </div>
            </div>
            <div class="col-12 text-right">
                <button v-if="editing" class="btn btn-dark" v-on:click="clearForm">Temizle</button>
                <v-executer v-if="editing" :loading="deleting" class="mr-1 ml-1" variant="danger" text="Sil" :action="deleteValue"></v-executer>
                <v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer>
            </div>
            <div class="col-12">
                <v-table    ref="table"
                            :fields="fields"
                            name="registry-document-value"
                            :buttons="buttons"
                            with-items
                            :items="values"
                            search
                            :settings="false"
                            pagination="client"></v-table>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard,BFormCheckbox } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
export default {
    components:{
        BCard,
        BFormCheckbox
    },
    data(){
        return{
            loading:false,
            deleting:false,
            types:[],
            editing:null,
            documents:[],
            rememberDocument:true,
            registryDocumentValue:{
                Id:null,
                RegistryDocumentValueTypeId:null,
                RegistryDocumentId:null,
                Name:null,
                Code:null
            },
            values:[],
            fields:[
                {name:"İsim",key:"Name",thClass:'w-34'},
                {name:"Kod",key:"Code",thClass:'w-33'},
                {name:"Tip",key:"RegistryDocumentValueTypeName",thClass:'w-33'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"EditIcon",variant:"primary",action:this.edit},
            ]
        }
    },
    mounted(){
        this.getDocuments()
        this.getTypes()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.registryDocumentValue.Id = null
            this.registryDocumentValue.RegistryDocumentValueTypeId = null
            this.registryDocumentValue.Name = null
            this.registryDocumentValue.Code = null
            if(!this.rememberDocument) this.registryDocumentValue.RegistryDocumentId = null
        },
        getDocuments(){
            EmployeeOperationsApi.Employee.RegistryFile.GetAll().then(res=>{
                this.documents = res.data.Data
            })
        },
        getTypes(){
            EmployeeOperationsApi.Employee.RegistryFile.GetValueType().then(res=>{
                this.types = res.data.Data
            })
        },
        getValues(){
            if(this.registryDocumentValue.RegistryDocumentId){
                EmployeeOperationsApi.Employee.RegistryFile.GetValues(this.registryDocumentValue.RegistryDocumentId).then(res=>{
                    this.values = res.data.Data
                })
            }else this.values = []
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.registryDocumentValue.Id = item.Id
            this.registryDocumentValue.RegistryDocumentValueTypeId = item.RegistryDocumentValueTypeId
            this.registryDocumentValue.RegistryDocumentId = item.RegistryDocumentId
            this.registryDocumentValue.Name = item.Name
            this.registryDocumentValue.Code = item.Code
        },
        createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.Employee.RegistryFile.CreateOrUpdateValue(this.editing,this.registryDocumentValue).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.clearForm()
                    this.getValues()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        deleteValue(){
            if(this.registryDocumentValue.Id){
                this.deleting = true
                EmployeeOperationsApi.Employee.RegistryFile.DeleteValue(this.registryDocumentValue.Id).then(res=>{
                    this.$result(res)
                    if(res.data.Success){
                        this.deleting = false
                        this.clearForm()
                        this.getValues()
                    }
                }).catch(err=>{
                    this.deleting = false
                    this.$result(null,err)
                })
            }
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id == this.registryDocumentValue.RegistryDocumentValueTypeId)
            },
            set:function(value){
                this.registryDocumentValue.RegistryDocumentValueTypeId = value?.Id || null
            }  
        },
        document:{
            get:function(){
                return this.documents.find(b=>b.Id == this.registryDocumentValue.RegistryDocumentId)
            },
            set:function(value){
                this.registryDocumentValue.RegistryDocumentId = value?.Id || null
            }  
        }
    }
}
</script>

<style>

</style>